"use client";

import { useEffect } from "react";

import { SingleFileView } from "@/components/views/single-file-view";

export interface SourceFileViewerPageProps {
  /** Signed read-only ``/files/d/{jwt}`` URL. */
  url: string;
  fileName: string;
  onClose: () => void;
}

/** Full-page pop-out for a read-only source chat link. */
export function SourceFileViewerPage({
  url,
  fileName,
  onClose,
}: SourceFileViewerPageProps) {
  useEffect(() => {
    document.title = fileName;
    return () => {
      document.title = import.meta.env.APP_NAME ?? "Layer Nine";
    };
  }, [fileName]);

  return (
    <div className="flex h-screen flex-col bg-background text-foreground">
      <SingleFileView
        sourceUrl={url}
        sourceFileName={fileName}
        onClose={onClose}
        className="h-full"
      />
    </div>
  );
}
